import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { filterToValidAttributes } from '@zocdoc-frontend-common/utils-dom-property';

const validMethodValues = new Set(['get', 'post', 'dialog']);

export default function Form(props) {
    const {
        children,
        method: methodFromProps,
        onSubmit = noop,
        ...otherProps
    } = props;

    const method = validMethodValues.has(methodFromProps)
        ? methodFromProps
        : 'post';

    const handleSubmit = useCallback(
        e => {
            e.preventDefault();
            onSubmit(e);
        },
        [onSubmit]
    );

    return (
        <form
            {...filterToValidAttributes(otherProps)}
            method={method}
            onSubmit={handleSubmit}
        >
            {children}
        </form>
    );
}

Form.propTypes = {
    method: PropTypes.oneOf(Array.from(validMethodValues)),
    onSubmit: PropTypes.func,
};
